export default "__VITE_ASSET__BWKUsSbZ__"